import Vue from "vue";
import { NavigationGuard } from "vue-router";
import { auth } from "@/utils/LtkAuth0";
import { useAppStore } from "@/stores/app";
import Authentication from ".";

const $authentication = new Authentication();

/**
 * Implicit On navigation guard requires the next route to specify
 * that it does not require auth before checking authentication status
 * of the user.
 */
const redirectRoute = async (config: any) => {
  const {
    isAuthenticated,
    isLambdaAuthorized,
    accessToken,
    idTokenClaims,
    to,
    next,
  } = config;
  if (!isLambdaAuthorized) {
    await $authentication.lambdaAuthorize(
      accessToken,
      idTokenClaims,
      "login"
    );
  }
  if (!isAuthenticated) {
    return next({ path: "/login" });
  } else if (isAuthenticated && to.name === "Login") {
    return next({ path: "/logged-in" });
  } else {
    return next();
  }
};

const navigationGuard: NavigationGuard = async (to, from, next) => {
  const openId = $authentication.openID;
  if (!openId) {
    await $authentication.initLiff();
  }
  const fullPath = to.fullPath;

  if (!to.meta.requiresAuth && to.name !== "Login") {
    if (!to.meta.requiresAuth) {
      if (to.fullPath === "/" || !to.name) {
        return next({ path: "login" });
      }
      return next();
    }
    return next();
  }

  try {
    const accessToken = await auth.getAccessToken() || "";
    const idTokenClaims = (await auth.getIdTokenClaims())?.__raw;
    const isAuthenticated = await auth.isAuthenticated();
    if (openId) {
      const isLambdaAuthorized = await $authentication.checkLoggedIn(
        openId,
        accessToken
      );
      return redirectRoute({
        isAuthenticated,
        accessToken,
        idTokenClaims,
        isLambdaAuthorized,
        to,
        next,
      });
    } else {
      window.alert("Not a valid line user");
      return;
    }
  } catch (error) {
    if (
      error instanceof Error &&
      error.message.toLowerCase() === "login required"
    ) {
      await auth.login({
        options: {
          appState: {
            target: `${fullPath}`,
          },
          openUrl: (url: string) => {
            window.location.replace(`${url}&lang=zh-TW`);
          }
        },
        next: `${fullPath}`,
      });
    } else {
      useAppStore().setHasError(true);
      return next(false);
    }
  }
  return next();
};

export default navigationGuard;
